import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{
    key: string;
    value: string;
}>;

export const DispatchSetFieldValue: HandlerType = props => { 
    props.dispatch({
        type: "Custom/SurveyForm/SetFieldValue",
        key: props.parameter.key,
        value: props.parameter.value,
    } as any);
};

export const chain = [DispatchSetFieldValue];

const setFieldValue = createHandlerChainRunner(chain, "SetFieldValue");
export default setFieldValue;
